import * as orm from "@client/features/orm";
import {useAppSelector} from "@client/store";
import {Context, _Types, getServerData} from "@reactivated";
import React from "react";

export const LiveSiteContext = (props: {children: React.ReactNode}) => {
    const {context} = getServerData();
    const profile = useAppSelector(orm.getProfile);
    const liveContext: _Types["Context"] = {
        ...context,
        profile,
        realm: "app",
    };
    const setValue = () => {};

    return (
        <Context.Provider value={{...liveContext, setValue}}>
            {props.children}
        </Context.Provider>
    );
};
